import { Directive } from '@angular/core';
import {
    AbstractControl,
    NG_VALIDATORS,
    ValidationErrors,
    Validator
} from '@angular/forms';

export function NotOnlyWhitespace(
    control: AbstractControl
): ValidationErrors | null {
    return (control.value || '').trim().length !== 0
        ? null
        : { notOnlyWhitespace: false };
}

@Directive({
    selector:
        '[notOnlyWhitespace][formControlName],[notOnlyWhitespace][formControl],[notOnlyWhitespace][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: WhitespaceValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class WhitespaceValidatorDirective implements Validator {
    validate(control: AbstractControl): ValidationErrors | null {
        return NotOnlyWhitespace(control);
    }
}
